import React from "react";
import HostelSearch from "../../components/AdminTabs/AdminStudentHostelFee/HostelSearch";

const AdminResult = () => {
  return (
    <div>
      <HostelSearch />
    </div>
  );
};

export default AdminResult;
